import React, { useState, useEffect } from 'react';
import { useGetRecords } from './hooks';
import { Loader, Table, Pager, Field, Input } from '@smartplatform/ui';
import { CreateNew } from './CreateNew';

import store from '../store';

const { PER_PAGE } = store.ui;

export const ModelTable = ({ model, records, options, tabName, children, path, showAddButton = true, limit = PER_PAGE, filters, type, ...rest }) => {
	const [filter, setFilter] = useState({ limit: limit });
	const [nameSearch, setNameSearch] = useState('');
	const [currentPage, setCurrentPage] = useState();
	const [recordsData, setRecordsData] = useState(records);
	console.log('records', records);

	const data = recordsData || useGetRecords({ model, tabName, options, filter });
	useEffect(() => {
		let where;

		where = {
			and: [{ name: nameSearch && nameSearch !== '' ? { regexp: '/' + nameSearch + '/i' } : undefined }, { type: type && type.id }],
		};
		options && options.where && where.and.push(options.where);

		setCurrentPage(1);
		setFilter({ where, ...filter.where, limit, search: nameSearch.trim().length ? nameSearch.trim() : undefined });
		records && setRecordsData(records.filter(e => e.name.toLowerCase().indexOf(nameSearch.toLowerCase()) >= 0));
		records && !nameSearch && setRecordsData(records);
	}, [nameSearch, options]);

	const onPagerChange = page => {
		setFilter({ ...filter, limit, skip: limit * (page - 1) });
		setCurrentPage(page);
	};

	if (!data) {
		return <Loader />;
	}

	return (
		<>
			<div style={{ display: 'flex', alignItems: 'center', marginBottom: '2rem' }}>
				{showAddButton && <CreateNew link={`${path}/new`} name={`Новая запись`} />}
				<Input
					style={{ marginLeft: '1rem', flexGrow: 1 }}
					value={nameSearch}
					placeholder="Поиск по имени"
					onChange={e => setNameSearch(e.target.value)}
				/>
			</div>

			{filters && filters()}
			<Table records={data} {...rest}>
				{children}
			</Table>
			<Pager
				itemsPerPage={limit}
				totalCount={data.totalCount}
				current={currentPage}
				onChange={page => onPagerChange(page)}
				directChange={true}
			/>
		</>
	);
};
